import React, { useState, useContext } from 'react';
import {
  Container,
  makeStyles,
} from '@material-ui/core';
import {
  TabPanel,
  TabList,
  TabContext
} from '@material-ui/lab';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Page from 'src/components/Page';
import Perfil from './Profile';
import Senha from './Senha';
import Permissoes from './Permissoes';

import { AuthContext } from '../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  tabela: {
    backgroundColor: '#f4f6f8',
    '& > .MuiTabs-scroller': {
      backgroundColor: '#f4f6f8',
    }
  },
  tab: {
    padding: '24px 0px'
  }
}));

const Account = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  console.log(auth);
  const [aba, setAba] = useState('0');
  const handleChange = (event, newValue) => {
    setAba(newValue);
  };
  if (!auth.isLoggedIn || auth.userPermission === false) {
    return (
      <Page
        className={classes.root}
        title="Perfil"
      >
        <Container maxWidth="lg">
          AAAAA
        </Container>
      </Page>
    );
  }

  return (
    <Page
      className={classes.root}
      title="Perfil"
    >
      <Container maxWidth="lg">
        <TabContext value={aba}>
          <AppBar position="static" color="default">
            <TabList
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              aria-label="simple tabs example"
              className={classes.tabela}
            >
              <Tab label="GERAL" value="0" id="perfil" />
              <Tab label="SENHA" value="1" id="senha" />
              {auth.userPermission.nome === 'Gestor do Sistema' ? (<Tab label="ADMIN" value="2" id="admin" />) : (<Tab disabled />)}
            </TabList>
          </AppBar>
          <TabPanel className={classes.tab} value="0">
            <Perfil />
          </TabPanel>
          <TabPanel className={classes.tab} value="1">
            <Senha />
          </TabPanel>
          {auth.userPermission.nome === 'Gestor do Sistema' ? (
            <TabPanel className={classes.tab} value="2">
              <Permissoes />
            </TabPanel>
          ) : ''}
        </TabContext>
      </Container>
    </Page>
  );
};

export default Account;
